import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PlantInvoiceDetailsModel } from './plant-invoice-details.model';


export class GetAllInvoiceDetailsResponse extends GlobalResponseObject{
    data: PlantInvoiceDetailsModel[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: PlantInvoiceDetailsModel[] ){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}